import { toast } from '@/components/toast'
import { useVersionCheck } from '@/utils/hooks'
import { useTranslate } from '@ur-solutions/react-hooks'
import { useEffect } from 'react'

const TOAST_ID = 'new-version-available'

/**
 * Prompts rather than reloads on its own: an unsolicited reload would discard
 * open dialogs and half-entered rows.
 */
export const VersionCheck: React.FC = () => {
  const isOutdated = useVersionCheck()

  const translations = useTranslate({
    newVersionAvailable: 'common.new-version-available',
    reload: 'common.reload',
  })

  useEffect(() => {
    if (!isOutdated) return

    // Top-center keeps it clear of the save bars that sit at the bottom of
    // several pages. Only this toast moves; the rest keep the Toaster default.
    toast.info(translations.newVersionAvailable, {
      id: TOAST_ID,
      position: 'top-center',
      duration: Infinity,
      closeButton: true,
      action: {
        label: translations.reload,
        onClick: () => window.location.reload(),
      },
    })
  }, [isOutdated, translations])

  return null
}
